var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaignEmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20902"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#235594"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0714 10.0126L25.9099 9.17405C25.9938 9.0902 25.9938 8.95045 25.9099 8.8666C25.8261 8.78275 25.6863 8.78275 25.6025 8.8666L24.7919 9.67716C24.708 9.76101 24.708 9.90076 24.7919 9.98461C24.8757 10.0964 24.9875 10.0964 25.0714 10.0126Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.0435 10.5713C25.0435 10.6831 25.1273 10.7949 25.2671 10.7949H26.4689C26.5807 10.7949 26.6925 10.711 26.6925 10.5713C26.6925 10.4595 26.6087 10.3477 26.4689 10.3477H25.2671C25.1553 10.3477 25.0435 10.4595 25.0435 10.5713Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.289 9.67702C24.4008 9.67702 24.5126 9.59317 24.5126 9.45342V8.2236C24.5126 8.1118 24.4288 8 24.289 8C24.1772 8 24.0654 8.08385 24.0654 8.2236V9.48137C24.0934 9.59317 24.1772 9.67702 24.289 9.67702Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.8169 10.0124C10.9008 10.0963 11.0405 10.0963 11.1244 10.0124C11.2082 9.92859 11.2082 9.78884 11.1244 9.70499L10.2859 8.89443C10.202 8.81058 10.0623 8.81058 9.97842 8.89443C9.89456 8.97828 9.89456 9.09008 9.97842 9.17393L10.8169 10.0124Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.4471 10.767H10.649C10.7608 10.767 10.8726 10.6832 10.8726 10.5434C10.8726 10.4316 10.7887 10.3198 10.649 10.3198H9.4471C9.3353 10.3198 9.25145 10.4037 9.25145 10.5434C9.2235 10.6832 9.30735 10.767 9.4471 10.767Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.5996 9.67702C11.7114 9.67702 11.8232 9.59317 11.8232 9.45342V8.2236C11.8232 8.1118 11.7393 8 11.5996 8C11.4878 8 11.376 8.08385 11.376 8.2236V9.48137C11.376 9.59317 11.4598 9.67702 11.5996 9.67702Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.0836 8.47503C17.9998 8.41913 17.9159 8.41913 17.8321 8.47503L16.2109 9.70484H19.7047L18.0836 8.47503Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M11.2919 17.531C10.9845 17.3074 11.0404 16.8881 11.0404 16.8322V14.9875V13.562L9.08385 15.0154C9.02795 15.0713 9 15.1272 9 15.1831V25.2173L15.2609 20.5216L11.2919 17.531Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.8045 15.0433L24.8479 13.5898C24.8479 14.065 24.8479 16.3849 24.8479 16.86C24.82 16.9718 24.9318 17.3072 24.5964 17.5588L20.6274 20.5215L26.8883 25.2172V15.183C26.8883 15.1271 26.8604 15.0712 26.8045 15.0433Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M20.2081 20.7453L18.0839 22.3384C18.0559 22.3384 17.9441 22.4502 17.8043 22.3384C17.1056 21.8074 15.5404 20.6614 15.6522 20.7173L15.5963 20.7453L9 25.7484V25.7763C9 25.8881 9.08385 25.9999 9.2236 25.9999H26.6925C26.8043 25.9999 26.9162 25.9161 26.9162 25.7763V25.7484L20.264 20.7732L20.2081 20.7453Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.6552 10.124C11.5434 10.124 11.4316 10.2079 11.4316 10.3476V17.0557C11.4316 17.1116 11.4596 17.1955 11.5155 17.2234L17.8043 21.9191C17.8882 21.975 17.972 21.975 18.0559 21.9191L24.3447 17.2234C24.4006 17.1955 24.4285 17.1116 24.4285 17.0557V10.3476C24.4285 10.2358 24.3447 10.124 24.2049 10.124H11.6552ZM15.9316 17.2514C15.9316 17.3632 15.8478 17.475 15.708 17.475H13.1366C13.0248 17.475 12.913 17.3911 12.913 17.2514V13.5619C12.913 13.4501 12.9969 13.3383 13.1366 13.3383H15.708C15.8198 13.3383 15.9316 13.4222 15.9316 13.5619V17.2514ZM22.7515 17.447H17.3292C17.2174 17.447 17.1056 17.3632 17.1056 17.2234C17.1056 17.0837 17.1894 16.9998 17.3292 16.9998H22.7515C22.8633 16.9998 22.9751 17.0837 22.9751 17.2234C22.9751 17.3632 22.8633 17.447 22.7515 17.447ZM22.7515 15.6302H17.3292C17.2174 15.6302 17.1056 15.5464 17.1056 15.4066C17.1056 15.2948 17.1894 15.183 17.3292 15.183H22.7515C22.8633 15.183 22.9751 15.2669 22.9751 15.4066C22.9472 15.5184 22.8633 15.6302 22.7515 15.6302ZM22.7515 13.7855H17.3292C17.2174 13.7855 17.1056 13.7017 17.1056 13.5619C17.1056 13.4501 17.1894 13.3383 17.3292 13.3383H22.7515C22.8633 13.3383 22.9751 13.4222 22.9751 13.5619C22.9472 13.7017 22.8633 13.7855 22.7515 13.7855ZM22.7515 12.1364H13.1366C13.0248 12.1364 12.913 12.0526 12.913 11.9128C12.913 11.801 12.9969 11.6892 13.1366 11.6892H22.7236C22.8354 11.6892 22.9472 11.7731 22.9472 11.9128C22.9472 12.0526 22.8633 12.1364 22.7515 12.1364Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M15.5125 13.7856H13.3604V17.0279H15.5125V13.7856Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignEmailLogo);
export default __webpack_public_path__ + "static/media/CampaignEmailLogo.2c9bf93ae071895d061d35af356131ba.svg";
export { ForwardRef as ReactComponent };